{
  "name": "portal",
  "version": "8.6.4",
  "private": true,
  "license": "UNLICENSED",
  "scripts": {
    "ng": "nx",
    "affected:plain": "nx show projects --affected --type=app",
    "start:portal": "nx run portal:serve --hmr --host 0.0.0.0 --disable-host-check",
    "start:portal:inno": "nx run portal:serve:innovation --hmr --host 0.0.0.0 --disable-host-check",
    "start:management": "nx run management:serve --hmr --host 0.0.0.0 --disable-host-check",
    "start:management:inno": "nx run management:serve:innovation --hmr --host 0.0.0.0 --disable-host-check",
    "start:docker:management": "npm run start:management -- --configuration dev",
    "build:portal": "NODE_OPTIONS='--max-old-space-size=8192' nx run portal:build --configuration=production",
    "build:portal:stage": "NODE_OPTIONS='--max-old-space-size=8192' nx run portal:build --configuration=stage",
    "analyze:portal": "npm run build:portal -- --stats-json && esbuild-visualizer --metadata dist/apps/portal/stats.json --filename dist/apps/portal/bundle-analysis.html --open",
    "build:management": "NODE_OPTIONS='--max-old-space-size=8192' nx run management:build --configuration=production",
    "build:management:stage": "NODE_OPTIONS='--max-old-space-size=8192' nx run management:build --configuration=production",
    "analyze:management": "npm run build:management -- --stats-json && esbuild-visualizer --metadata dist/apps/management/stats.json --filename dist/apps/management/bundle-analysis.html --open",
    "test:all": "NODE_OPTIONS='--max-old-space-size=8192' nx run-many -t coverage --exclude=api",
    "test:portal": "NODE_OPTIONS='--max-old-space-size=8192' nx run portal:coverage",
    "test:management": "NODE_OPTIONS='--max-old-space-size=8192' nx run management:coverage",
    "test:libs": "NODE_OPTIONS='--max-old-space-size=8192' nx affected -t test --exclude=portal,management,api",
    "test:libs:all": "NODE_OPTIONS='--max-old-space-size=8192' nx run-many --all -t test --exclude=portal,management,api",
    "oxlint": "oxlint apps libs",
    "oxlint:fix": "oxlint apps libs --fix",
    "lint:fix": "npm run oxlint:fix ; NODE_OPTIONS='--max-old-space-size=8192' nx run-many --all --targets=lint,stylelint --fix --exclude=api ; npm run format",
    "lint": "npm run oxlint && NODE_OPTIONS='--max-old-space-size=3072' nx affected -t lint,stylelint,prettier --parallel=4 --exclude=api",
    "lint:all": "npm run oxlint && NODE_OPTIONS='--max-old-space-size=3072' nx run-many --all -t lint,stylelint,prettier --parallel=4 --exclude=api",
    "format": "prettier --write --log-level warn --no-error-on-unmatched-pattern \"apps/**/*.ts\" \"libs/**/*.ts\"",
    "lint:portal": "oxlint apps/portal && NODE_OPTIONS='--max-old-space-size=8192' nx run portal:lint && npm run lint:style:portal",
    "lint:management": "oxlint apps/management && NODE_OPTIONS='--max-old-space-size=8192' nx run management:lint && npm run lint:style:management",
    "lint:style:all": "nx run-many --all --target=stylelint",
    "lint:style:portal": "nx run portal:stylelint",
    "lint:style:management": "nx run management:stylelint",
    "lint:api": "NODE_OPTIONS='--max-old-space-size=8192' nx run api:lint --fix",
    "clean:angular": "rm -rf ./.angular/*",
    "clean:api": "rm -rf ./libs/api/src/lib/*",
    "generate:openapi": "openapi-generator-cli generate -i http://0.0.0.0:3000/api-docs/portal/swagger.json -g typescript-angular -o ./libs/api/src/lib --additional-properties=ngVersion=14.1.0,tsConfig=./libs/api/tsconfig.json",
    "generate:api": "npm run clean:angular && npm run clean:api && npm run generate:openapi && node scripts/patch-generated-api.js && npm run lint:api",
    "prepare": "lefthook install || true",
    "sonar": "sonar-scanner",
    "build:storybook": "NODE_OPTIONS='--max-old-space-size=8192' nx run design-system:build-storybook",
    "start:storybook": "NODE_OPTIONS='--max-old-space-size=8192' nx run design-system:storybook --verbose=true",
    "deploy:storybook": "npx chromatic --project-token=chpt_39f4ecf89e4709d --build-script-name=build:storybook",
    "sentry:sourcemaps": "sentry-cli sourcemaps inject --org measured-jk --project javascript-angular dist && sentry-cli sourcemaps upload --org measured-jk --project javascript-angular dist",
    "local-setup": "rm -rf node_modules && rm -rf .npmcache && rm -rf .angular && rm -rf .nx && npm i nx && npm i",
    "typecheck:portal": "tsc -p apps/portal/tsconfig.typecheck.json --noEmit"
  },
  "engines": {
    "node": ">=22.18.0",
    "npm": ">=9.8.1"
  },
  "dependencies": {
    "@angular-slider/ngx-slider": "21.0.0",
    "@angular/animations": "21.2.17",
    "@angular/cdk": "21.2.14",
    "@angular/common": "21.2.17",
    "@angular/compiler": "21.2.17",
    "@angular/core": "21.2.17",
    "@angular/forms": "21.2.17",
    "@angular/localize": "21.2.17",
    "@angular/platform-browser": "21.2.17",
    "@angular/platform-browser-dynamic": "21.2.17",
    "@angular/router": "21.2.17",
    "@floating-ui/dom": "0.5.4",
    "@highcharts/map-collection": "^2.0.1",
    "@langchain/angular": "0.4.5",
    "@langchain/core": "^1.1.44",
    "@ng-bootstrap/ng-bootstrap": "20.0.0",
    "@ngrx/effects": "21.1.1",
    "@ngrx/signals": "21.1.1",
    "@ngrx/store": "21.1.1",
    "@ngrx/store-devtools": "21.1.1",
    "@okta/okta-angular": "7.1.0",
    "@okta/okta-auth-js": "7.5.1",
    "@popperjs/core": "^2.11.8",
    "@primeuix/themes": "2.0.3",
    "@sentry/angular": "10.56.0",
    "@sentry/cli": "2.42.0",
    "@tanstack/angular-query-experimental": "5.101.0",
    "@types/dompurify": "3.2.0",
    "angular-google-tag-manager": "1.13.0",
    "angular-highcharts": "20.0.1",
    "angular-ng-autocomplete": "^2.0.9",
    "animejs": "3.2.2",
    "aos": "2.3.4",
    "bootstrap": "^5.3.3",
    "canvas-confetti": "1.9.3",
    "dayjs": "^1.11.4",
    "dexie": "4.0.8",
    "dompurify": "3.3.3",
    "file-saver": "2.0.5",
    "graphology": "0.25.4",
    "graphology-dag": "0.4.1",
    "graphology-layout": "0.6.1",
    "graphology-layout-forceatlas2": "^0.10.1",
    "graphology-types": "0.24.7",
    "highcharts": "^11.4.3",
    "highcharts-angular": "4.0.1",
    "html2canvas": "^1.4.1",
    "jspdf": "^2.5.2",
    "locale-codes": "1.3.1",
    "marked": "18.0.0",
    "material-design-icons": "3.0.1",
    "mathjs": "11.8.0",
    "moment-timezone": "0.5.43",
    "ngx-cookie-service": "21.3.1",
    "ngx-pendo": "2.4.0",
    "ngx-sortable": "2.1.0",
    "numeral": "2.0.6",
    "primeicons": "7.0.0",
    "primeng": "21.1.9",
    "quill": "2.0.3",
    "rxjs": "^7.5.6",
    "sigma": "2.4.0",
    "socket.io-client": "4.8.3",
    "sortablejs": "1.15.2",
    "tslib": "^2.4.0",
    "uuid": "^8.3.2",
    "xlsx": "^0.18.5",
    "xlsx-js-style": "^1.2.0",
    "zone.js": "0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/architect": "0.2102.18",
    "@angular-devkit/build-angular": "21.2.18",
    "@angular-devkit/core": "21.2.18",
    "@angular-devkit/schematics": "21.2.18",
    "@angular-eslint/eslint-plugin": "21.4.0",
    "@angular-eslint/eslint-plugin-template": "21.4.0",
    "@angular-eslint/template-parser": "21.4.0",
    "@angular/cli": "21.2.18",
    "@angular/compiler-cli": "21.2.17",
    "@angular/language-service": "21.2.17",
    "@chromatic-com/storybook": "5.2.1",
    "@nx/angular": "22.7.6",
    "@nx/eslint": "22.7.6",
    "@nx/eslint-plugin": "22.7.6",
    "@nx/js": "22.7.6",
    "@nx/storybook": "22.7.6",
    "@nx/web": "22.7.6",
    "@openapitools/openapi-generator-cli": "2.18.4",
    "@schematics/angular": "21.2.18",
    "@storybook/addon-docs": "10.4.6",
    "@storybook/angular": "10.4.6",
    "@swc-node/register": "1.11.1",
    "@swc/core": "1.15.43",
    "@swc/helpers": "0.5.23",
    "@tailwindcss/typography": "0.5.19",
    "@types/animejs": "3.1.12",
    "@types/aos": "3.0.7",
    "@types/canvas-confetti": "1.6.4",
    "@types/file-saver": "2.0.5",
    "@types/jasmine": "5.1.4",
    "@types/jasminewd2": "~2.0.13",
    "@types/karma": "^6.3.8",
    "@types/karma-chrome-launcher": "^3.1.4",
    "@types/karma-jasmine": "^4.0.5",
    "@types/karma-jasmine-html-reporter": "^1.7.3",
    "@types/karma-summary-reporter": "^3.1.3",
    "@types/lodash-es": "^4.17.12",
    "@types/node": "18.16.9",
    "@types/numeral": "2.0.5",
    "@types/semver-compare": "1.0.3",
    "@types/sortablejs": "1.15.8",
    "@types/uuid": "^8.3.4",
    "@typescript-eslint/eslint-plugin": "8.61.1",
    "@typescript-eslint/parser": "8.61.1",
    "angular-eslint": "21.4.0",
    "autoprefixer": "10.4.16",
    "axios": "1.12.0",
    "chromatic": "16.10.0",
    "cypress": "15.5.0",
    "cypress-mochawesome-reporter": "3.8.2",
    "cypress-xpath": "2.0.1",
    "esbuild-visualizer": "^0.7.0",
    "eslint": "^9.8.0",
    "eslint-config-prettier": "10.1.8",
    "eslint-plugin-oxlint": "1.69.0",
    "jasmine-core": "5.2.0",
    "jasmine-spec-reporter": "7.0.0",
    "karma": "6.4.4",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "^2.2.1",
    "karma-jasmine": "5.1.0",
    "karma-jasmine-html-reporter": "2.1.0",
    "karma-junit-reporter": "2.0.1",
    "karma-spec-reporter": "^0.0.36",
    "karma-summary-reporter": "^4.0.1",
    "lcov-parse": "^1.0.0",
    "lefthook": "2.1.9",
    "lodash-es": "^4.17.21",
    "ng-packagr": "21.2.5",
    "nx": "22.7.6",
    "nx-stylelint": "13.5.2",
    "oxlint": "1.69.0",
    "parse-diff": "^0.11.1",
    "postcss": "8.4.31",
    "prettier": "3.3.3",
    "semver-compare": "^1.0.0",
    "storybook": "10.4.6",
    "stylelint": "^14.10.0",
    "stylelint-config-idiomatic-order": "^8.1.0",
    "stylelint-config-standard": "^25.0.0",
    "stylelint-config-twbs-bootstrap": "^4.0.0",
    "tailwindcss": "3.3.3",
    "ts-node": "10.9.1",
    "typescript": "5.9.3",
    "typescript-eslint": "8.61.1",
    "webpack": "5.94.0"
  }
}
